import { httpClient } from "../../../shared/api";

export const copilotApi = {
  // provider/model are only consulted by the backend when conversationId is
  // omitted (a brand-new conversation) -- fixed for that conversation once
  // created, so callers resuming an existing conversation should simply
  // omit them (or pass undefined) rather than re-sending the same values.
  sendMessage: (conversationId, message, provider, model) =>
    httpClient.post("/ai-copilot/chat", {
      conversation_id: conversationId,
      message,
      ...(conversationId ? {} : { provider, model }),
    }),

  listConversations: () => httpClient.get("/ai-copilot/conversations"),

  getConversation: (conversationId) =>
    httpClient.get(`/ai-copilot/conversations/${conversationId}`),

  listModels: () => httpClient.get("/ai-copilot/models"),
};
